import { Box, Flex } from "@chakra-ui/react";
import React, { Fragment, useEffect } from "react";
import GameSelector from "../../components/GameComponents/GameSelector/GameSelector";
import { useSelector } from "react-redux";
import useCheckLogin from "../../hook/useCheckLogin";
import GameTypeSelector from "../../components/GameComponents/GameTypeSelector/GameTypeSelector";
import PlatformSelectorRight from "../../components/GameComponents/PlatformSelector/PlatformSelector_right";
import MarqueeList from "../../components/marquee/marqueeList";
import useDeviceType from "../../hook/useDeviceType";
import { useParams } from "react-router-dom";

const GamePlatformPage = () => {
  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const { gameType, topGameList, newGameList } = isHandleAllGame;

  const { gameMainType } = useParams();

  const isMobile = useDeviceType() === "Mobile";

  const { isMachineUser, isMachineDomain } = useCheckLogin();

  // const navigate = useNavigate();

  // useEffect(() => {
  //   if (gameMainType) {
  //     const current_type = routeMapping(gameMainType)?.origin;
  //     if (!gameType?.includes(current_type)) {
  //       return navigate("/slots");
  //     }
  //   }
  // }, [gameType, gameMainType]);
  return (
    <Fragment>
      <Box
        as="section"
        px="common-y"
        position="sticky"
        top={"70px"}
        zIndex={1}
        bgColor="rgba(0,0,0,0.3)"
        display={{ base: "block", xl: "none" }}
        display={{ base: "block", xl: "none" }}
      >
        <GameTypeSelector ltr />
      </Box>
      <Box flex={1}>
        <Box
          display={{
            base: "none",
            md: "block",
          }}
          position="relative"
          zIndex={1000}
          w={{
            base: "100%",
          }}
          mt="15px"
        >
          {isMachineUser || isMachineDomain ? (
            <Flex gap="30px" alignItems={"center"}>
              <PlatformSelectorRight />
              <Box maxW="40%" w="100%">
                <MarqueeList />
              </Box>
            </Flex>
          ) : (
            <MarqueeList />
          )}
        </Box>
        <Flex
          gap={{
            base: "0",
            md: "10px",
          }}
          py={{
            base: "0",
            md: "home-space",
          }}
          px="common-y"
          mb={{
            base: "60px",
            sm: "0px",
          }}
          w={{
            base: "100%",
          }}
          flexDirection={{
            base: "column-reverse",
            md: "row",
          }}
        >
          {" "}
          <Box
            py="home-space"
            px="common-y"
            mb={{
              base: "60px",
              sm: "0px",
            }}
            w={{
              base: "100%",
            }}
          >
            <GameSelector
              hiddenTitle
              isGridXLayout={isMachineUser || isMachineDomain}
              topLayout={false}
            />{" "}
          </Box>
          {isMachineUser || isMachineDomain ? null : (
            <Box>
              <PlatformSelectorRight direction={isMobile ? false : "col"} />
            </Box>
          )}{" "}
        </Flex>
        {/* <JackpotList /> */}
      </Box>
    </Fragment>
  );
};

export default GamePlatformPage;
